import { createContext, useMemo, useState } from 'react';
import { SETTING_CONTAINERS as SETTING_CONTAINER_NAME } from 'src/interfaces/enums';

interface ISettingsOverlayContext {
  containerName: SETTING_CONTAINER_NAME;
  setContainerName: (containerName: SETTING_CONTAINER_NAME) => void;
}

export const SettingsOverlayContext = createContext<ISettingsOverlayContext>({} as ISettingsOverlayContext);

interface ISettingsOverlayContextProvider {
  children?: React.ReactNode;
}

const SettingsOverlayProvider = ({ children }: ISettingsOverlayContextProvider) => {
  const [containerName, setContainerName] = useState(SETTING_CONTAINER_NAME.MAIN);

  const valueContext = useMemo(() => ({ containerName, setContainerName }), [containerName]);

  return <SettingsOverlayContext.Provider value={valueContext}>{children}</SettingsOverlayContext.Provider>;
};

type WithSettingsOverlayProviderProps<T> = T & {
  children?: React.ReactNode;
};

export function withSettingsOverlayProvider<T>(Component: React.ComponentType<T>) {
  return function (props: WithSettingsOverlayProviderProps<T>) {
    return (
      <SettingsOverlayProvider>
        <Component {...props}>{props.children}</Component>
      </SettingsOverlayProvider>
    );
  };
}
